import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getPrices} from "../../api/client";

const priceNotes = [
    "Итоговая стоимость зависит от марки, модели и состояния техники;",
    "стоимость запчастей согласуется отдельно до начала ремонта;",
    "для корпоративных клиентов возможны индивидуальные условия;",
    "после диагностики формируется предварительная смета работ.",
];

function Prices() {
    const [priceCards, setPriceCards] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let isMounted = true;

        getPrices()
            .then((prices) => {
                if (isMounted) {
                    setPriceCards(prices);
                    setError("");
                }
            })
            .catch((requestError) => {
                if (isMounted) {
                    setError(requestError.message);
                }
            })
            .finally(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <main className="prices-page">
            <section className="prices-hero">
                <div className="prices-hero-content">
                    <span className="prices-eyebrow">Стоимость услуг</span>
                    <h1>Примерные цены</h1>
                    <p className="prices-hero-description">
                        Здесь отображается базовая информация по стоимости диагностики, технического обслуживания и
                        ремонтных работ. Точные цены зависят от состояния автомобиля, сложности неисправности и
                        выбранных запчастей.
                    </p>
                </div>

                <Link className="prices-home-link" to="/">
                    На главную
                </Link>
            </section>

            <section className="prices-section">
                <div className="prices-section-heading">
                    <span>Ориентиры</span>
                    <h2>Базовые категории работ</h2>
                </div>

                {isLoading && <p className="prices-status">Загружаем цены...</p>}
                {error && <p className="prices-status prices-status-error">{error}</p>}

                {!isLoading && !error && priceCards.length === 0 && (
                    <p className="prices-status">Прайс пока пуст. Администратор может добавить услуги в админке.</p>
                )}

                {!isLoading && !error && priceCards.length > 0 && (
                    <div className="prices-grid">
                        {priceCards.map((card) => (
                            <article className="prices-card" key={card.id}>
                                <span>{card.price}</span>
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                            </article>
                        ))}
                    </div>
                )}
            </section>

            <section className="prices-section prices-info-panel">
                <div>
                    <span className="prices-eyebrow">Важно учитывать</span>
                    <h2>Что влияет на цену</h2>
                </div>

                <ul>
                    {priceNotes.map((note) => (
                        <li key={note}>{note}</li>
                    ))}
                </ul>
            </section>
        </main>
    );
}

export default Prices;
